import { IupTemplateBuilding } from "../models/upTemplate.model";

const clearExcelData = (data: any[][]) => {
  const cleanData = data.filter(row => row.some(cell => cell !== null));
  const headerRow = cleanData[0];
  const dataRows = cleanData.slice(1);

  return {
    headerRow,
    dataRows,
    cleanData
  };
};

export default clearExcelData;
